import React from 'react'
import {
  CustomerAgencyDataSearchAuditSnapshotV1,
  IAuditEventData,
} from '../../../api'
import { useDetailStyles } from './useDetailStyles'
import { Box } from 'cs-kevlar-react'
import { UnavailableDetails } from './UnavailableDetails'
import { resolveEventData } from './utils'
import { DetailField } from './DetailField'

interface CustomerAgencyDataSearchDetailsProps {
  eventData: IAuditEventData
}

export const CustomerAgencyDataSearchDetails: React.FunctionComponent<CustomerAgencyDataSearchDetailsProps> = ({
  eventData,
}) => {
  const classes = useDetailStyles()
  const info = resolveEventData<CustomerAgencyDataSearchAuditSnapshotV1>(
    eventData,
    nameof<CustomerAgencyDataSearchAuditSnapshotV1>(),
  )

  if (!info) return <UnavailableDetails />

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField label="Search Type" original={info.searchType} />

        <DetailField label="Search Value" original={info.searchValue} />
      </Box>
    </React.Fragment>
  )
}
